// API configuration - similar to scoreboard pattern
// In production, uses relative paths (served from same domain)
// In development, uses full URL (always normalize to .../api so /place routes resolve correctly)

function normalizeDevApiBase(url: string): string {
  const t = url.replace(/\/$/, '');
  if (t.endsWith('/api')) return t;
  return `${t}/api`;
}

export const API_BASE_URL = import.meta.env.PROD
  ? '/api'
  : normalizeDevApiBase(import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787');

export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL || 'https://cdn.redditcfb.com';
export const CDN_IMAGE_PATH = import.meta.env.VITE_CDN_IMAGE_PATH || '60x60';

/**
 * Base URL for fetch() that reads CDN bytes (e.g. Place canvas PNG). In Vite dev, defaults to a same-origin
 * proxy — see vite.config.ts `server.proxy['/__cdn-proxy']` — so localhost is not blocked by CDN CORS.
 * `<img src={CDN_BASE_URL/...}>` still uses CDN_BASE_URL (no CORS for display).
 */
export const CDN_FETCH_BASE_URL = (
  import.meta.env.VITE_CDN_FETCH_BASE_URL != null && import.meta.env.VITE_CDN_FETCH_BASE_URL !== ''
    ? import.meta.env.VITE_CDN_FETCH_BASE_URL
    : import.meta.env.DEV
      ? '/__cdn-proxy'
      : CDN_BASE_URL
).replace(/\/$/, '');

/** Bump when final Place PNGs on CDN change (query `?v=` on `_place.png`). Can mirror server PLACE_CDN_CACHE_BUST. */
export const PLACE_IMAGE_CACHE_BUST = String(import.meta.env.VITE_PLACE_IMAGE_CACHE_BUST || '').trim();

/** Optional: match PLACE_FROZEN on the API so the UI hides editors before the first fetch (avoids flicker). */
export const PLACE_UI_FROZEN =
  import.meta.env.VITE_PLACE_FROZEN === 'true' || import.meta.env.VITE_PLACE_FROZEN === '1';
